/* eslint-disable max-params -- utility functions require multiple parameters */
/* istanbul ignore file */
import { updateResource, destroyResource } from 'iguazu-rest';
import uuidV4 from 'uuid/v4';

export default function deleteDocs(dispatch, documentId, fileId, body) {
  return dispatch(destroyResource({
    id: {
      formDataAPI: false,
      documentId,
      fileId,
      correlationId: uuidV4(),
    },
    resource: 'imageViewerDocUpload',
    opts: { body },
  })).then(
    (data) => data,
    (error) => error
  );
}

export function submitDocs(dispatch, body) {
  return dispatch(updateResource({
    id: { correlationId: uuidV4() },
    resource: 'imageViewerDocUpload',
    opts: { body },
  })).then(
    (data) => data,
    (error) => error
  );
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${Number.parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

export function formatFileName(name, maxLength) {
  if (name.length > maxLength) {
    return `${name.slice(0, maxLength)}...`;
  }
  return name;
}
/* eslint-enable max-params -- utility functions require multiple parameters */
